import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Utils } from '@app-shared/utils';

export type PropertyCardMetric = string;

@Component({
	selector: 'app-property-card',
	templateUrl: './property-card.component.html',
	styleUrls: ['./property-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertyCardComponent {
	@Input() imageUrl?: string;
	@Input() imageAlt?: string;
	@Input() price: number;
	@Input() address?: string;
	@Input() metrics: PropertyCardMetric[] = [];
	@Input() showImagePlaceholder = true;
	@Input() placeholderIcon = 'fal fa-home';
	@Input() actionAriaLabel?: string;
	@Input() actionDisabled = false;
	@Input() interactive = false;
	@Input() showActionIcon = true;
	@Input() ariaLabel?: string;

	@Output() action = new EventEmitter<void>();
	@Output() cardClick = new EventEmitter<void>();

	onAction(event: MouseEvent | KeyboardEvent): void {
		event.preventDefault();
		event.stopPropagation();

		if (!this.actionDisabled) {
			this.action.emit();
		}
	}

	onCardClick(_event: MouseEvent): void {
		if (!this.interactive) {
			return;
		}

		this.cardClick.emit();
	}

	onCardKeyup(event: KeyboardEvent): void {
		if (!this.interactive) {
			return;
		}

		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			this.cardClick.emit();
		}
	}

	get computedAriaLabel(): string | null {
		if (!this.interactive) {
			return null;
		}

		const fallbackLabel = this.address;

		return this.ariaLabel || fallbackLabel || null;
	}
}
